import { Action, createAction } from '@reduxjs/toolkit';
import * as actionTypes from './actionTypes';

export const setBanner = createAction<{
  field: FlattenKeys<BannerState>;
  value: any;
}>(actionTypes.SET_BANNER);

export const resetBanner = createAction<void>(actionTypes.RESET_BANNER);

const bannerActions = (dispatch: <T>(action: Action) => T) =>
  Object.assign(
    {},
    {
      setBanner: <T extends FlattenKeys<BannerState>>(payload: {
        field: T;
        value: DeepType<BannerState, T>;
      }) => dispatch<void>(setBanner(payload)),
      resetBanner: () => dispatch<void>(resetBanner()),
    },
  );

export default bannerActions;
